module.exports = __webpack_public_path__ + "img/backHome_03.b06e77e1.png";